import { isBarcodeOpenAtom } from '@atoms/barcodeAtoms';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useUser from '@hooks/auth/useUser';
import BarcodeIcon from '@icons/BarcodeIcon';
import CouponIcon from '@icons/CouponIcon';
import StampIcon from '@icons/StampIcon';
import { useFlow } from '@router/stackflow';
import { useSetAtom } from 'jotai';

import UserRewardItem from './UserRewardItem';

function UserRewards() {
  const { user } = useUser();
  const { push } = useFlow();
  return (
        <Column spacing={16} css={css`
            padding: 0 20px;;
        `}>
            <Text color={colors.gray8} fontWeight='bold' size='xl'>
                {`${user?.nickname || '고객'}`}님
            </Text>
            <Container>
                <UserRewardItem icon={StampIcon}
                                label='스탬프'
                                content={user?.stampCount?.toString() || ''}
                                onClick={() => push('StampsActivity', {})} />
                <UserRewardItem icon={CouponIcon}
                                label='쿠폰'
                                content={`${user?.couponCount || 0}개`}
                                onClick={() => push('CouponActivity', { type: 'MY' })} />
                <UserRewardItem icon={BarcodeIcon}
                                onClick={() => push('BarcodeModal', {})}
                                label='바코드'
                                content='멤버십 적립' />
            </Container>
        </Column>
  );
}

const Container = styled.div`
    background-color: ${colors.gray1};
    border-radius: 8px;
    padding: 0 8px;
    width: 100%;
    margin-bottom: 28px;
    display: flex;
`;

export default UserRewards;
